export const PER_PAGE_POLICY = 'PER_PAGE_POLICY';
export const PAGE_POLICY = 'PAGE_POLICY';
export const PAGES_POLICY = 'PAGES_POLICY';
export const ARRAY_LIST_POLICY = 'ARRAY_LIST_POLICY';
export const POLICY = 'POLICY';
export const IS_OPEN_CLAIM_MODAL = 'IS_OPEN_CLAIM_MODAL';
export const IS_OPEN_RENEWAL_MODAL = 'IS_OPEN_RENEWAL_MODAL';
